<section 
  data-component="popup-site-speedbump"
  role="dialog" 
  [attr.aria-describedby]= "ariaDescribedBy">

  <h1 
    id="{{ariaTitleId}}"
    role="heading"
    tabindex="0"
    class="focus-here"
    [innerHTML]="modalData?.headerTxt"></h1>

  <span class="separator" aria-hidden="true"></span>

  <p 
    id="{{ariaBodyId}}"
    tabindex="0"
    [innerHTML]="modalData?.bodyTxt"></p>

  <span class="separator separator-rule separator-large" aria-hidden="true"></span>

  <section 
    data-form-id="signoff">
    <div class="button-box reverse-medium-min">

      <button
        class="secondary-large" 
        (click)="cancel()">
        {{modalData?.copy$$btn_cancel?.TEXT}}
      </button>

      <button 
        class="primary-large" 
        type="submit"
        (click)="continue()">
        {{modalData?.copy$$btn_continue?.TEXT}}
      </button>

    </div>
  </section> 
</section>